import { useAccountList } from '@ltvco/refresh-lib/hooks';
import { AccountListsV2 } from '@ltvco/refresh-lib/v2';
import { useEffect } from 'react';

export function Lists() {
  const { data: lists, isLoading } = useAccountList();

  useEffect(() => {
    document.title = 'Report Lists - NumberGuru';
  }, []);

  return (
    <AccountListsV2
      lists={lists || []}
      isLoading={isLoading}
      hideContactProExport={true}
    />
  );
}
